import {
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { getNewFileFormGroup } from '@app/helpers/form.helper';
import { WizardSection } from '@app/models/project-setup.models';
import { FileType } from '@app/models/shared.enums';
import { WizardStore } from '@app/stores/project-setup/wizard.store';
import { CardComponent } from '@app/ui-components/card/card.component';
import { UploadFilesComponent } from '@app/ui-components/upload-files/upload-files.component';
import { SectionJFormGroup } from '../+helpers/section-j-form.helper';

@Component({
  selector: 'app-section-j',
  imports: [ReactiveFormsModule, CardComponent, UploadFilesComponent],
  templateUrl: './section-j.component.html',
  styleUrl: './section-j.component.scss',
})
export class SectionJComponent implements OnInit {
  wizardStore = inject(WizardStore);
  private readonly destroyRef = inject(DestroyRef);
  projectId = input.required<string>();
  protected formGroup = signal<FormGroup<SectionJFormGroup> | null>(null);
  protected translationKey = 'projectWizard.sectionJForm.';

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.wizardStore
      .getSection(this.projectId(), WizardSection.J)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((form) => {
        this.formGroup.set(form as FormGroup<SectionJFormGroup>);
      });
  }

  createNewOtherDocs() {
    this.formGroup()!.controls.otherDocs.push(
      getNewFileFormGroup(this.fb, FileType.document, false, true),
    );
  }

  removeOtherDocs($event: number) {
    this.formGroup()!.controls.otherDocs.removeAt($event);
  }

  createNewImages() {
    this.formGroup()!.controls.images.push(
      getNewFileFormGroup(this.fb, FileType.image, false, true),
    );
  }

  removeImages($event: number) {
    this.formGroup()!.controls.images.removeAt($event);
  }

  createNewVideos() {
    this.formGroup()!.controls.videos.push(
      getNewFileFormGroup(this.fb, FileType.video, false, true),
    );
  }

  removeVideos($event: number) {
    this.formGroup()!.controls.videos.removeAt($event);
  }
}
